import React from "react";
import { FiX } from "react-icons/fi";

const InfluencerViewModal = ({ influencer, onClose }) => {
  if (!influencer) return null;

  const {
    username,
    name,
    email,
    mobile,
    title,
    rating,
    price,
    platform,
    category,
    location,
    gender,
    age,
    language,
    image,
    avatar,
    bio,
    reviewCount,
    followers,
    following,
    posts,
    contentType,
    isActive
  } = influencer;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-5xl w-full max-h-[90vh] overflow-y-auto shadow-xl">

        {/* HEADER */}
        <div className="sticky top-0 bg-white border-b px-6 py-4 flex justify-between items-center">
          <h2 className="text-xl font-semibold">Influencer Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <FiX size={22} />
          </button>
        </div>

        <div className="p-6 space-y-8">

          {/* ===== PROFILE SECTION ===== */}
          <div className="flex items-center gap-6">
            <img
              src={avatar || image || "https://via.placeholder.com/120"}
              alt={name}
              className="h-28 w-28 rounded-full object-cover border"
            />

            <div>
              <h3 className="text-2xl font-semibold">{name}</h3>
              <p className="text-gray-500">@{username}</p>

              <div className="mt-2 flex flex-wrap gap-2">
                {Array.isArray(platform) &&
                  platform.map((p, i) => (
                    <span
                      key={i}
                      className="px-3 py-1 text-xs bg-blue-100 text-blue-700 rounded-full"
                    >
                      {p}
                    </span>
                  ))}

                <span
                  className={`px-3 py-1 text-xs rounded-full ${
                    isActive
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {isActive ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
          </div>

           {/* ===== BIO ===== */}
          <div>
            <h4 className="text-lg font-semibold mb-2">Bio</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
            {bio}

            </p>
          </div>

          {/* ===== BASIC INFO ===== */}
          <Section title="Basic Information">
            <Info label="Email" value={email} />
            <Info label="Mobile" value={mobile} />
            <Info label="Title" value={title} />
            <Info label="Category" value={category} />
            <Info label="Location" value={location} />
            <Info label="Gender" value={gender} />
            <Info label="Age" value={age} />
            <Info label="Language" value={language} />
            <Info label="Content Type" value={contentType} />
          </Section>

          {/* ===== ANALYTICS ===== */}
          <Section title="Analytics">
            <Info label="Price" value={`₹${price}`} />
            <Info label="Followers" value={followers?.toLocaleString()} />
            <Info label="Following" value={following?.toLocaleString()} />
            <Info label="Posts" value={posts?.toLocaleString()} />
            <Info label="Rating" value={`${rating || 0} / 5`} />
            <Info label="Review Count" value={reviewCount} />
          </Section>

        </div>
      </div>
    </div>
  );
};

export default React.memo(InfluencerViewModal);


/* ---------- Reusable Components ---------- */

const Section = ({ title, children }) => (
  <div>
    <h4 className="text-lg font-semibold mb-4">{title}</h4>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {children}
    </div>
  </div>
);

const Info = ({ label, value }) => (
  <div>
    <p className="text-xs text-gray-500">{label}</p>
    <p className="text-sm font-medium text-gray-800">
      {value || "-"}
    </p>
  </div>
);
